import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { modelOf } from '../../../../prop-types';
import AccountStore from '../../../../store/AccountStore';
import CheckoutStore from '../../../../store/CheckoutStore';
import CheckoutPageModule from '../../../../types/checkout/CheckoutPageModule';
import CheckoutModule from '../../common/CheckoutModule';
import CheckoutRecipientLoggedInLayout from '../CheckoutRecipientLoggedInLayout';
import CheckoutRecipientVisitorForms from '../CheckoutRecipientVisitorForms';

const CheckoutRecipientInfoModule = ({
  checkoutStore,
  accountStore,
  onOrderUpdate,
  orderNumber,
}) => {
  const { order } = checkoutStore;
  const { shippingInfoAlerts } = order;
  const loggedIn = accountStore?.loggedIn === true;

  const handleUpdate = (args) => {
    onOrderUpdate({
      module: CheckoutPageModule.SHIPPING_INFO_MODULE,
      ...args,
    });
  };

  return (
    <CheckoutModule
      className="CheckoutRecipientInfoModule"
      generalAlerts={shippingInfoAlerts.general}
      errorAlerts={shippingInfoAlerts.errors}
      title={
        <FormattedMessage
          id="checkout.deliveryForm.title"
          defaultMessage="Buyer details"
        />
      }
      orderNumber={orderNumber}
      module={CheckoutPageModule.SHIPPING_INFO_MODULE}
    >
      {loggedIn ? (
        <CheckoutRecipientLoggedInLayout onOrderUpdate={handleUpdate} />
      ) : (
        <CheckoutRecipientVisitorForms onOrderUpdate={handleUpdate} />
      )}
    </CheckoutModule>
  );
};

CheckoutRecipientInfoModule.propTypes = {
  checkoutStore: modelOf(CheckoutStore).isRequired,
  accountStore: modelOf(AccountStore),
  onOrderUpdate: PropTypes.func.isRequired,
  orderNumber: PropTypes.number.isRequired,
};

export default inject(
  'checkoutStore',
  'accountStore'
)(observer(CheckoutRecipientInfoModule));
